<script>
import Footer from "../components/Footer.svelte";
import Header from "../components/header/Header.svelte";
import Modals from "../components/Modals.svelte";
import TopbarSignedIn from "../components/TopbarSignedIn.svelte";

let complaint = {
  number: "4008904",
};
</script>

<div class="container" id="wrapper">
  <TopbarSignedIn />
  <Header />
  <div class="complaint-six">
    <div class="row">
      <div class="col-xs-12">
        <div class="row fill-white">
          <div class="col-xs-12">
            <div id="content" class="main-content">
              <script type="text/javascript">
              $(document).ready(function () {
                // Checkbox 1
                $("[name=CHK1]").click(function (e) {
                  var div = $(this).closest("div.reklamation"),
                    chk1 = $(".chk1", div);

                  if (this.checked) {
                    chk1.removeClass("hidden");
                  } else {
                    chk1.addClass("hidden");
                  }
                });

                // Select 1
                $("[name=CHK2]").change(function (e) {
                  var div = $(this).closest("div.reklamation"),
                    chk2 = $(".chk2", div);

                  if (this.value === "J") {
                    chk2.removeClass("hidden");
                  } else {
                    chk2.addClass("hidden");
                  }
                });

                // Select 2
                $("[name=CHK3]").change(function (e) {
                  var div = $(this).closest("div.reklamation"),
                    chk3 = $(".chk3", div);

                  if (this.value === "N") {
                    chk3.removeClass("hidden");
                  } else {
                    chk3.addClass("hidden");
                  }
                });
              });
              </script>
              <!-- contenttop -->
              <div id="contenttop" class="row">
                <div class="col-xs-12">
                  <ul class="breadcrumb">
                    <li class="active">Min sida</li>
                    <li>
                      <a href="/shop/IboxServlet?p=IXS850">Reklamation / retur</a>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Workflow -->
              <div class="workflow">
                <ul class="breadcrumb breadcrumb-secondary mt-md">
                  <li><a href="#"><span>1. Ärende</span></a></li>
                  <li><a href="#"><span>2. Rader</span></a></li>
                  <li><a href="#"><span>3. Anmärkningar</span></a></li>
                  <li><a href="#"><span>4. Leveransadress</span></a></li>
                  <li><a href="#"><span>5. Boka</span></a></li>
                  <li class="active-step"><span>6. Kvitto</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <svg
        width="65"
        height="65"
        viewBox="0 0 65 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M59.5827 30.0083V32.5C59.5794 38.3403 57.6882 44.023 54.1913 48.7007C50.6944 53.3784 45.7791 56.8004 40.1784 58.4563C34.5778 60.1123 28.5919 59.9134 23.1135 57.8895C17.6352 55.8655 12.9578 52.1248 9.77903 47.2253C6.60028 42.3259 5.09045 36.5301 5.47472 30.7025C5.859 24.8748 8.11678 19.3275 11.9114 14.8879C15.7059 10.4482 20.834 7.35412 26.5307 6.06702C32.2274 4.77992 38.1876 5.36879 43.5223 7.74579"
          stroke="#12AD50"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M59.5833 10.8333L32.5 37.9437L24.375 29.8187"
          stroke="#12AD50"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
      <h2>Din reklamation är mottagen</h2>
      <p>
        Vi har tagit emot din reklamation som kommer att behandlas inom en
        arbetsdag.
      </p>
      <p class="new-row">
        Reklamationen har nummer
        {complaint.number}
        och du kan följa den i
        <a href="#">listan för reklamationer och returer</a>.
      </p>
    </div>
  </div>
</div>

<Footer />
<Modals />
